import { Service } from "../../../service.js";
import { env } from "../../../env.js";

import { toastUtils } from "../../../util/toast.utils.js";

class HistoricoDashboardService extends Service {
  constructor() {
    super();

    this.url = env.url + "historico-tarefas/dashboard";
  }

  async concluir(historicoTarefaId, faseId, motivoBaixa) {
    try {
      const response = await super.post(this.url + `/baixar`, {
        faseId,
        historicoTarefaId,
        motivoBaixa,
      });

      if (response.status === 200) {
        toastUtils.successToast("Tarefa concluída com sucesso!");
        return true;
      } else {
        toastUtils.dangerToast(
          "Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações."
        );
      }
    } catch {
      toastUtils.dangerToast(
        "Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações."
      );
      return false;
    }
  }

  async concluirManualmenteDashboardDoCliente(historicoTarefaId, motivoBaixa) {
    try {
      const response = await super.post(this.url + `/baixar-dashboard-cliente`, {
        historicoTarefaId,
        motivoBaixa,
      });

      if (response.status === 200) {
        toastUtils.successToast("Tarefa concluída com sucesso!");
        return true;
      } else {
        toastUtils.dangerToast(
          "Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações."
        );
      }
    } catch {
      toastUtils.dangerToast(
        "Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações."
      );
      return false;
    }
  }

  async reabrir(historicoTarefaId, motivoReabertura) {
    try {
      const response = await super.post(this.url + `/reabrir`, {
        historicoTarefaId,
        motivoReabertura,
      });

      if (response.status === 200) {
        toastUtils.successToast("Tarefa reaberta com sucesso!");
        return true;
      } else {
        toastUtils.dangerToast(
          "Ocorreu um erro durante a reabertura da tarefa. Por favor contate nosso suporte para mais informações."
        );
      }
    } catch {
      toastUtils.dangerToast(
        "Ocorreu um erro durante a reabertura da tarefa. Por favor contate nosso suporte para mais informações."
      );
      return false;
    }
  }

  async listarHistorico(objetoDeFiltros, removerPagina = false) {
    if (removerPagina) {
      delete objetoDeFiltros.pagina;
    }
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    return super.get(this.url + queryString);
  }

  async listarHistoricoCards(objetoDeFiltros, removerPagina = false) {
    if (removerPagina) {
      delete objetoDeFiltros.pagina;
    }
    const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
    return super.get(env.url + "historico-tarefas/dashboard-cards" + queryString);
  }

  async delete(item) {
    return await super.delete(this.url, item);
  }

  async post(item) {
    const response = await super.post(this.url, item);
    if (response.status === 201) {
      toastUtils.successToast("Tarefa cadastrada com sucesso!");
      setTimeout(() => {
        window.location.reload(true);
      }, 3000);
    } else {
      throw new Error("HTTP " + response.status);
    }
  }

  async excluirMultiplas(ids = [], motivoExclusao = "") {
    const url = `${this.url}/excluir-multiplas`;
    const objPost = {
      ids,
      motivoExclusao,
    };

    const response = await super.post(url, objPost);

    if (response.status === 201 || response.status === 200) {
      toastUtils.successToast("Tarefa(s) excluída(s) com sucesso!");
      return response;
    } else {
      toastUtils.dangerToast("Não foi possível excluir as tarefas!");
      throw new Error("HTTP " + response.status);
    }
  }

  async transferirResponsavelEDepartamento(historicosId = [], usuarioId, departamentoId, isTransferenciaIndividual) {
    const url = `${this.url}/transferir-departamento-responsavel`;
    const objPost = {
      historicosId,
      usuarioId,
      departamentoId,
      isTransferenciaIndividual
    };

    const response = await super.post(url, objPost);

    if (response.status === 201 || (response.status === 200 && !isTransferenciaIndividual)) {
      toastUtils.successToast("Tarefa(s) transferida(s) com sucesso!");
      return response;
    } else if (response.status === 201 || (response.status === 200 && isTransferenciaIndividual)) {
      toastUtils.successToast("Tarefa transferida com sucesso!");
      return response;
    } else {
      toastUtils.dangerToast("Não foi possível transferir a(s) tarefa(s)!");
      throw new Error("HTTP " + response.status);
    }
  }

  async editarVencimentoTarefaAvulsa(id, prazoEntrega) {
    const url = `${this.url}/editar-prazo`;

    const obj = {
      id,
      prazoEntrega,
    };

    const response = await super.patch(url, obj);
    const messageResponse = await response.json();
    const message = messageResponse.message;

    if (response.status === 200) {
      toastUtils.successToast(message);
      return response;
    } else if (response.status == 400) {
      toastUtils.dangerToast(message);
      throw new Error("HTTP " + response.status);
    } else {
      toastUtils.dangerToast("Prazo de entrega inválido!");
      throw new Error("HTTP " + response.status);
    }
  }
}

export const historicoDashboardService = new HistoricoDashboardService();
